import { Bulletin } from "./types";
import { openBulletin } from "./shared";

const BulletinRowData = ({ bulletin }: { bulletin: Bulletin }) => {
  const date = bulletin.date ? new Date(bulletin.date).toLocaleDateString() : "No date";
  const underwriterName = bulletin.underwriter?.name || "N/A";
  return (
    <div
      key={bulletin.id}
      style={{
        marginBottom: "8px",
        padding: "4px",
        borderBottom: "1px solid #eee"
      }}
    >
      <span>
        <strong>Number:</strong> {bulletin.number ? `#${bulletin.number}` : ""} | <strong>Date:</strong> {date} |{" "}
        <strong>Underwriter:</strong> {underwriterName}
        <span
          onClick={() => {
            openBulletin(bulletin.url, false);
          }}
          style={{
            color: "#0066cc",
            marginLeft: "8px",
            cursor: "pointer"
          }}
        >
          [View]
        </span>
        <span
          onClick={() => {
            openBulletin(bulletin.url, true);
          }}
          style={{
            color: "#0066cc",
            marginLeft: "8px",
            cursor: "pointer"
          }}
        >
          [Download]
        </span>
      </span>
    </div>
  );
};

export default BulletinRowData;
